import Content from './Content';

export * from './Content';

export default Content;
